module.exports = __webpack_public_path__ + "img/mindful_days_365--active.03768a75.svg";